import { render, staticRenderFns } from "./KeywordSearch.vue?vue&type=template&id=535afc0e&scoped=true&"
import script from "./KeywordSearch.vue?vue&type=script&lang=js&"
export * from "./KeywordSearch.vue?vue&type=script&lang=js&"
import style0 from "./KeywordSearch.vue?vue&type=style&index=0&id=535afc0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535afc0e",
  null
  
)

export default component.exports